module.exports = __webpack_public_path__ + "static/media/IB_core.979d97b7.png";